import {
  EnhancementProductStat,
  EnhancementReportStat,
  EnhancementReportStatsResponse
} from '../../../models/enhancement/enhancement-report-stats'
import {TableData} from './Top20Table'

const formatNumber = (num: number): string => 
  Number.isInteger(num) ? num.toString() : num.toFixed(2)

export function Top20ByOnCallHoursTableData(requests: EnhancementReportStat[], requestType: string) {

  const onCallRequests = requests.filter(request => request.requestType === `${requestType}`)

  const groupedRequests = onCallRequests.reduce((acc, request) => {
    const key = `${request.employee}-${request.department}-${request.team}`
    if (!acc[key]) {
      acc[key] = {
        employee: request.employee,
        department: request.department,
        team: request.team,
        totalHours: 0
      }
    }
    acc[key].totalHours += request.finalPaidHours
    return acc
  }, {} as { [key: string]: { employee: string; department: string; team: string; totalHours: number } })

  const resultArray = Object.values(groupedRequests)

  const top20 = resultArray
    .sort((a, b) => b.totalHours - a.totalHours)
    .slice(0, 20)

  const tableData: TableData = {
    title: `Top 20 Employees By ${requestType}`,
    columnHeaders: ['Employee', 'Department', 'Team', `${requestType} Hours`],
    rows: top20.map(item => [
      item.employee,
      item.department,
      item.team,
      formatNumber(item.totalHours)
    ])
  }

  return tableData
}

export function Top20ProductsTableData(data: EnhancementProductStat[]) {

  const tableData: TableData = {
    title: `Top 20 Products Called Out`,
    columnHeaders: ['Product', 'Call Out Occurences', 'Called Out Hours'],
    rows: data.map(item => [
      item.product,
      formatNumber(item.totalCallOuts),
      formatNumber(item.totalCalledOutHours),
    ])
  }

  return tableData
}